import withState from '../../../../utils/withState';
import {apiV2GetTransactionDetails} from "../../../../api/merchant/transactions";
import filter from "mn-utils/filter";
import {Box, CircularProgress, Grid} from "@material-ui/core";
import React from "react";
import {backLocation, pushLocation} from "../../../../router";
import ButtonDownload from "../../../dumb/Button/DownloadA";
import {
  DisplayIdMerchant,
  DisplayDataMerchant,
  DisplayAmountMerchant,
  DisplayDateDetailedMerchant
} from "../../../helpers/Display/DataDisplay";
import {
  DetailedDataPrimaryDisplay,
  DetailedDataSecondaryDisplay
} from "../../../helpers/Display/DetailedData";
import {DisplayHashMerchant} from "../../../dumb/DisplayData";
import upperFirst from "mn-utils/upperFirst";
import Divider from "@material-ui/core/Divider";
import {LINK_TRANSACTION_REFUND} from "../../../../constants/links";
import RefundList from "../Refund/RefundList";
import {BtnBlueFilled} from "../../../helpers/Buttons";
import generateReceipt from "./utils/generateReceipt";
import handleDBItemData from "./utils/handleDBItemData";
import {MerchantPageHeader} from "../../../helpers/Display";

const TrxDetailsHeader = ({handlePrint}) => (
  <MerchantPageHeader
    title="Transaction details"
    backFN={backLocation}
    rightBlock={(
      <ButtonDownload
        onClick={handlePrint}
        name="Download Receipt"
      />
    )}
  />
);

const TrxDetailsPrimaryData = ({data}) => {
  const itemsParamsList = [
    {
      title: 'Transaction type',
      dataHandler: ({transactionKind}) => upperFirst(transactionKind || '').split('_').join(' '),
    },
    {
      title: 'Retailer name',
      key: 'retailerName',
    },
    {
      title: 'Status',
      dataHandler: ({status = ''}) => (
        <div className={`fw7 cFFBF43.pending c2CE889.completed
                cEE4F4F.failed c9C8FFF.requested ` + status}
        >{upperFirst(status)}</div>
      ),
    },
  ];


  return (
    <DetailedDataPrimaryDisplay
      data={data}
      itemsParamsList={itemsParamsList}
    />
  )
};

const TrxDetailsSecondaryData = ({data}) => {
  const itemsParamsList = [
    {
      title: 'Payment ID',
      dataHandler: ({paymentId}) => (
        <DisplayIdMerchant>{paymentId}</DisplayIdMerchant>
      )
    },
    {
      title: 'Order Description',
      skip: ({desc}) => !desc,
      dataHandler: ({desc}) => (
        <DisplayDataMerchant>{desc}</DisplayDataMerchant>
      )
    },
    {
      title: 'Transaction hash',
      dataHandler: ({hash, network, cryptoCurrencyCode}) => (
        <DisplayHashMerchant
          symbol={cryptoCurrencyCode}
          network={network}
          hash={hash}
        />
      )
    },
    {
      titleHandler: ({currencyPrefix}) => `Amount (${currencyPrefix === 'sc' ? 'stablecoin' : 'fiat'})`,
      dataHandler: ({currencyAmount, currencyCode}) => (
        <DisplayAmountMerchant
          amount={currencyAmount}
          symbol={currencyCode}
          type="fiat"
        />
      )
    },
    {
      title: 'Amount (crypto)',
      dataHandler: ({cryptoCurrencyAmount, cryptoCurrencyCode}) => (
        <DisplayAmountMerchant
          amount={cryptoCurrencyAmount}
          symbol={cryptoCurrencyCode}
          type="crypto"
        />
      )
    },
    {
      title: 'Network',
      skip: ({network, cryptoCurrencyCode, BPaySymbol}) => {
        return !network || cryptoCurrencyCode === BPaySymbol;
      },
      key: 'network'
    },
    {
      title: 'Retailer Fee',
      dataHandler: ({retailerFeeAmount, feeCode}) => {
        return (
          <DisplayAmountMerchant
            amount={retailerFeeAmount}
            symbol={feeCode}
            type="fiat"
          />
        );
      }
    },
    {
      title: 'Customer Fee',
      dataHandler: ({customerFeeAmount, feeCode}) => {
        return (
          <DisplayAmountMerchant
            amount={customerFeeAmount}
            symbol={feeCode}
            type="fiat"
          />
        );
      }
    },
    {
      title: 'Transaction date and time',
      dataHandler: ({date}) => (
        <DisplayDateDetailedMerchant date={date} />
      )
    },
    {
      title: 'Customer email',
      dataHandler: ({email}) => (
        <DisplayDataMerchant>
          {email}
        </DisplayDataMerchant>
      )
    }
  ]

  return (
    <DetailedDataSecondaryDisplay
      data={data}
      itemsParamsList={itemsParamsList}
    />
  )
};

export default withState((setState, self, onMount) => {

  self.state = {
    ...self.state,
    loading: true
  }

  const updateData = () => {
    const params = self.props.params || {};

    return apiV2GetTransactionDetails(filter({
      order_id: params.orderId || '',
      payment_id: params.paymentId || '',
      auction_id: params.auctionId || '',
      refund_id: params.refundId || '',
    })).then(handleDBItemData).then((data) => setState({data, loading: false}));
  }

  onMount(() => {
    updateData();
  });

  const handlePrint = () => {
    setState({
      loading: true,
    });

    const data = self.state.data || {};

    generateReceipt({
      ...data,
      transactionKind: upperFirst(data.transactionKind || '').split('_').join(' ')
    }).finally(() => {
      setState({
        loading: false,
      });
    });
  }

  return (state, props) => {
    if (state.loading) {
      return (
        <Box>
          <CircularProgress size="2.5rem" color="inherit" />
        </Box>
      )
    }

    const orderId = (props.params || {}).orderId;
    const data = state.data || {};

    const {
      paymentId,
      currencyPrefix,
      refundableAmount,
      status,
      cryptoCurrencyCode,
      refundsList
    } = data;

    const isSC = currencyPrefix === 'sc';

    const showRefundLink = !isSC
      && refundableAmount > 0
      && status === 'completed'
      && paymentId
      && cryptoCurrencyCode !== 'KLUB';

    return (
      <>
        <TrxDetailsHeader handlePrint={handlePrint} />
        <Box mt="3.5rem">
          <TrxDetailsPrimaryData data={data} />
        </Box>
        <Box mt="3rem" mb="4.5rem">
          <Divider />
        </Box>
        <Box>
          <TrxDetailsSecondaryData data={data} />
        </Box>
        {showRefundLink && (
          <Box maxWidth="30rem" mt="4.5rem">
            <BtnBlueFilled
              onClick={() => {
                pushLocation({
                  path: `${LINK_TRANSACTION_REFUND}/${orderId}/${paymentId}`,
                });
              }}
            >
              Refund
            </BtnBlueFilled>
          </Box>
        )}
        {!!refundsList.length && (
          <Box mt="4.5rem">
            <RefundList
              orderId={orderId}
              items={refundsList}
              callback={updateData}
            />
          </Box>
        )}
      </>
    )
  }
})
